import axios from "axios";
import { useAuth } from "../context/AuthContext";
import { API } from "../utils/constants";

// API helper hook
export const useApi = () => {
  const { token } = useAuth();
  const authHeaders = token ? { Authorization: `Bearer ${token}` } : {};
  
  return {
    get: (url) => axios.get(`${API}${url}`, { headers: authHeaders }),
    post: (url, data) => axios.post(`${API}${url}`, data, { headers: authHeaders }),
    put: (url, data) => axios.put(`${API}${url}`, data, { headers: authHeaders }),
    delete: (url) => axios.delete(`${API}${url}`, { headers: authHeaders })
  };
};
